/********************************************************************
 * Copyright (c) Certus Software, 2021.                             *
 *                                                                  *
 * This unpublished material is proprietary to Certus Software.     *
 * All rights reserved. The methods and techniques described        *
 * herein are considered confidential and/or trade secrets.         *
 * Reproduction or distribution, in whole or in part, is forbidden  *
 * except by express written permission of Certus Software.         *
 ********************************************************************/

import {AfterViewInit, Component, ElementRef, OnDestroy, OnInit} from '@angular/core';
import {UserService} from './@shared/_services/user.service';
import {ActivatedRoute, NavigationEnd, Router} from '@angular/router';
import {TranslateService} from '@ngx-translate/core';
import {AuthService} from './@shared/_services/auth.service';
import {NgcCookieConsentService} from 'ngx-cookieconsent';
import {environment} from 'src/environments/environment';
import {Subscription} from 'rxjs';
import {MatLegacyDialog as MatDialog} from '@angular/material/legacy-dialog';
import {CookieDetailsComponent} from './@shared/components/cookie-details/cookie-details.component';

declare let gtag: Function;

@Component({
  selector: 'app-root',
  template: `
    <router-outlet (activate)="onActivate($event)"></router-outlet>
    <app-spinner-component></app-spinner-component>`
})
export class AppComponent implements OnInit, OnDestroy, AfterViewInit  {

  private initializeSubscription: Subscription;

  constructor (
    private router: Router,
    private route: ActivatedRoute,
    private userService: UserService,
    public translate: TranslateService,
    private authService: AuthService,
    private ccService: NgcCookieConsentService,
    private elem: ElementRef,
    public dialog: MatDialog
  ) {
    /* LANGUAGE CHANGE - CONFIGURE TRANSLATION HERE */
    translate.addLangs(environment.defaultLanguageOrder);
    if (this.authService.getAppLanguage() && translate.getLangs().includes(this.authService.getAppLanguage())) {
      translate.use(this.authService.getAppLanguage());
      document.documentElement.lang = this.authService.getAppLanguage();
    } else {
      this.authService.saveAppLanguage(environment.defaultLanguage);
      translate.use(environment.defaultLanguage);
      document.documentElement.lang = environment.defaultLanguage;
    }
    const that = this;
    this.translate
      .get(['app.cookie.message', 'app.cookie.dismiss', 'app.cookie.learnMore', 'app.cookie.cookieConsent', 'home.resources.privacyPolicyUrl'])
      .subscribe(data => {
        this.initializeSubscription = this.ccService.popupOpen$.subscribe(
          () => {
            document.getElementsByClassName('cc-window')[0].setAttribute('aria-label', data['app.cookie.cookieConsent']);
            (document.getElementsByClassName('cc-link')[0] as HTMLElement).onclick = function () {
              return that.dialog.open(CookieDetailsComponent, {
                maxWidth: '100%',
                width: '100%'
              });
            };
          });
        this.ccService.getConfig().content = this.ccService.getConfig().content || {} ;
        // Override default messages with the translated ones
        this.ccService.getConfig().content.message = data['app.cookie.message'];
        this.ccService.getConfig().content.dismiss = data['app.cookie.dismiss'];
        this.ccService.getConfig().content.privacyPolicyLabel = data['app.cookie.learnMore'];
        // this.ccService.getConfig().content.privacyPolicyHref = data['home.resources.privacyPolicyUrl'];
        this.ccService.destroy(); // remove previous cookie bar (with default messages)
        this.ccService.init(this.ccService.getConfig()); // update config with translated messages
      });
  }

  ngOnInit() {
    const activationRoute = window.location.href;
    if (activationRoute.includes('/activate') || activationRoute.endsWith('/report')) {
      this.authService.destroyAuthorizationToken();
    }
    this.userService.populate();
  }

  ngAfterViewInit () {
    this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        gtag('config', environment.cookie_analytics_id,
          {
            'page_path': event.urlAfterRedirects,
            'cookieDomain': environment.cookie_domain
          }
        );
        if(!this.router.url.includes('#mainContent') && !this.router.url.includes('#guideContent')) {
          setTimeout(function (){
            document.getElementById('pgStart').focus();
          },200);
        }
      }
    });
  }

  onActivate(event) {
    window.scroll(0, 0);
  }

  ngOnDestroy() {
    this.initializeSubscription.unsubscribe();
  }
}


